import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { findAnnouncement } from '../../../announcements/announcements';
import { AnnouncementsLoadStatus, initialAnnouncementsState } from './announcementsState';

const pickCurrent = (eligibleIds: string[]): string | undefined =>
    eligibleIds.find((id) => findAnnouncement(id) !== undefined);

export const announcementsSlice = createSlice({
    name: 'announcements',
    initialState: initialAnnouncementsState,
    reducers: {
        setAnnouncementsLoadStatus: (state, action: PayloadAction<AnnouncementsLoadStatus>) => {
            state.loadStatus = action.payload;
        },
        setEligibleAnnouncements: (state, action: PayloadAction<string[]>) => {
            state.eligibleIds = action.payload;
            state.currentId = pickCurrent(action.payload);
            state.loadStatus = 'loaded';
        },
        clearCurrentAnnouncement: (state) => {
            const remaining = state.currentId
                ? state.eligibleIds.filter((id) => id !== state.currentId)
                : state.eligibleIds;
            state.eligibleIds = remaining;
            state.currentId = pickCurrent(remaining);
        },
    },
});

export const { setAnnouncementsLoadStatus, setEligibleAnnouncements, clearCurrentAnnouncement } =
    announcementsSlice.actions;

export default announcementsSlice.reducer;
